import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../store';
import { usersApi } from '../Users/userService';

interface IdResolverState {
    // Maps matrixId -> userId
    matrixIdToUserId: Record<string, string>;
    // Maps userId -> matrixId
    userIdToMatrixId: Record<string, string>;
}

const initialState: IdResolverState = {
    matrixIdToUserId: {},
    userIdToMatrixId: {},
};

const idResolverSlice = createSlice({
    name: 'idResolver',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // Handle resolveMatrixIds query fulfillment
        builder.addMatcher(
            usersApi.endpoints.resolveMatrixIds.matchFulfilled,
            (state, action) => {
                Object.entries(action.payload).forEach(([matrixId, userId]) => {
                    state.matrixIdToUserId[matrixId] = userId;
                    state.userIdToMatrixId[userId] = matrixId;
                });
            }
        );
        // Handle resolveUserIds query fulfillment
        builder.addMatcher(
            usersApi.endpoints.resolveUserIds.matchFulfilled,
            (state, action) => {
                Object.entries(action.payload).forEach(([userId, matrixId]) => {
                    state.userIdToMatrixId[userId] = matrixId;
                    state.matrixIdToUserId[matrixId] = userId;
                });
            }
        );
    },
});

// Selectors
export const selectMatrixIdToUserId = (state: RootState) => state.idResolver.matrixIdToUserId;
export const selectUserIdToMatrixId = (state: RootState) => state.idResolver.userIdToMatrixId;

export const selectUserIdFromMatrixId = (matrixId: string) => (state: RootState) => {
    return state.idResolver.matrixIdToUserId[matrixId] || '';
};

export const selectMatrixIdFromUserId = (userId: string) => (state: RootState) => {
    return state.idResolver.userIdToMatrixId[userId] || '';
};

export default idResolverSlice.reducer;
